'use client';

import Image from '@/components/Image';
import H3 from '@/components/ui/H3';
import { useLocale } from 'next-intl';

const partners = [
    {
        name: { en: 'Canada Media Fund', fr: 'Fonds des médias du Canada' },
        logo: '/img/partners/ca-media-fund.png',
        link: { en: 'https://cmf-fmc.ca/', fr: 'https://cmf-fmc.ca/fr/' },
    },
    {
        name: { en: 'SODEC', fr: 'SODEC' },
        logo: '/img/partners/sodec.png',
        link: { en: 'https://sodec.gouv.qc.ca/', fr: 'https://sodec.gouv.qc.ca/' },
    },
    {
        name: { en: 'Telefilm Canada', fr: 'Téléfilm Canada' },
        logo: '/img/partners/telefilm.png',
        link: { en: 'https://telefilm.ca/en', fr: 'https://telefilm.ca/fr' },
    },
    {
        name: { en: 'Ville de Montreal', fr: 'Ville de Montréal' },
        logo: '/img/partners/ville-de-montreal.png',
        link: { en: 'https://montreal.ca/en', fr: 'https://montreal.ca/' },
    },
    {
        name: {
            en: 'Consulate General of France in Québec',
            fr: 'Consulat général de France à Québec',
        },
        logo: '/img/partners/consulat-de-france.png',
        link: {
            en: 'https://montreal.consulfrance.org/',
            fr: 'https://montreal.consulfrance.org/',
        },
    },
    {
        name: { en: 'National Film Board of Canada', fr: 'Office national du film du Canada' },
        logo: '/img/partners/nfb.png',
        link: { en: 'https://www.nfb.ca/', fr: 'https://www.onf.ca/' },
    },
    {
        name: { en: 'MUBI', fr: 'MUBI' },
        logo: '/img/partners/air-canada.png',
        link: { en: 'https://mubi.com/en/ca/showing', fr: 'https://mubi.com/en/ca/showing' },
    },
    {
        name: { en: 'PHI Centre', fr: 'Centre PHI' },
        logo: '/img/partners/phi.png',
        link: { en: 'https://phi.ca/en/', fr: 'https://phi.ca/fr/' },
    },
    {
        name: { en: 'Fonds Bell', fr: 'Fonds Bell' },
        logo: '/img/partners/fierte-montreal.png',
        link: { en: 'https://fondsbell.ca/', fr: 'https://fondsbell.ca/' },
    },
    {
        name: { en: 'Hydro Québec', fr: 'Hydro Québec' },
        logo: '/img/partners/hydro-quebec.png',
        link: {
            en: 'https://www.hydroquebec.com/residentiel/',
            fr: 'https://www.hydroquebec.com/residentiel/',
        },
    },
    {
        name: { en: 'Fugues', fr: 'Fugues' },
        logo: '/img/partners/fugues.png',
        link: { en: 'https://www.fugues.com/', fr: 'https://www.fugues.com/' },
    },
];

const PartnersSection = () => {
    const locale = useLocale() as 'en' | 'fr';
    return (
        <div className="mt-20 md:mt-24 md:pt-24 flex flex-col gap-16 md:border-t border-white/50">
            {partners.map((partner, index) => (
                <a
                    key={index}
                    className="group relative flex items-center cursor-pointer max-md:h-12"
                    href={partner.link[locale]}
                    target="_blank"
                >
                    <Image
                        src={partner.logo}
                        alt={partner.name[locale]}
                        width={280}
                        height={280}
                        className={`absolute ${index === 0 ? 'md:top-0' : 'md:-top-24'} left-0 w-36 h-36 md:w-72 md:h-72 md:opacity-0 group-hover:opacity-100 transition-all duration-400 object-contain`}
                    />
                    <H3
                        text={partner.name[locale]}
                        className="max-md:text-2xl max-2xl:text-6xl ml-40 md:ml-96 group-hover:text-primary uppercase transition-colors duration-300"
                    />
                </a>
            ))}
        </div>
    );
};

export default PartnersSection;
